var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"lds-ring",style:({
    width: `${_vm.width}px`,
    height: `${_vm.width}px`,
  })})
}
var staticRenderFns = []

export { render, staticRenderFns }